import { render, staticRenderFns } from "./SingleTagMenu.vue?vue&type=template&id=40d2aedc&"
import script from "./SingleTagMenu.vue?vue&type=script&lang=js&"
export * from "./SingleTagMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports